import { OffsegAuthInfoType, G500LiteAuthInfoType } from '../feature/type/AuthInfoType';

export const common = {
	label: {
		companyCode: '法人コード',
		userCode: 'ユーザID',
		password: 'パスワード',
		companyId: '会社ID',
		loginId: 'ログインID',
	},
	buttonName: {
		cancel: 'キャンセル',
	},
	alert: {
		error: '入力内容をご確認の上、再度お試しください。',
		initPasswordChangeRequest: '安全運転管理サービスで初期パスワードを変更の上、再度お試しください。',
		loginLock: 'ログイン失敗が連続したため、このアカウントは一時的にロックされました。\nしばらく時間をおいてから再度お試しください。',
		localStorage: 'ブラウザのWebストレージでエラーが発生しました。\nG500Lite安全運転管理テレマティクスサービスのサポートページの\n取扱説明書をご確認ください。'
	},
};

export const loginPageMain = {
	appName: '共通ウェブポータルサービス',
	checkboxName: 'ログイン情報を記憶する',
	buttonName: 'ログイン',
	linkName: {
		forgetPassword: 'パスワードを忘れた場合はこちら',
		reregistration: 'G500Lite ログイン情報の再登録はこちら',
		offsegSupport: 'サポートページはこちら'
	},
};

export const registrationDialog = {
	title: 'G500Lite ログイン情報の登録',
	text: 'OffsegとG500Liteのアカウントを連携するためにG500Liteのログイン情報を入力してください。\n※G500Liteのログイン情報の登録は初回ご利用時、G500Liteのパスワード変更時、およびG500Liteのアカウント再作成時に必要です。',
	buttonName: {
		registration: '登録',
	},
};

export const reregistrationStep1Dialog = {
	title: 'G500Lite ログイン情報の再登録',
	text: 'STEP1: Offsegのログイン情報を入力してください。',
	buttonName: {
		confirmation: '確認',
	},
};

export const reregistrationStep2Dialog = {
	title: 'G500Lite ログイン情報の再登録',
	text: 'STEP2: G500Liteのログイン情報を入力してください。',
	supplementaryText: 'STEP1のご入力内容',
	buttonName: {
		registration: '登録',
		back: '戻る',
	},
};

export const loginFromList = (offsegAuthInfo: OffsegAuthInfoType, setOffsegAuthInfo: React.Dispatch<React.SetStateAction<OffsegAuthInfoType>>) => {
	return [
		{
			id: 'companyCode',
			label: common.label.companyCode,
			defaultValue: offsegAuthInfo.companyCode,
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setOffsegAuthInfo({ ...offsegAuthInfo, companyCode: e.target.value });
			},
		},
		{
			id: 'userCode',
			label: common.label.userCode,
			defaultValue: offsegAuthInfo.userCode,
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setOffsegAuthInfo({ ...offsegAuthInfo, userCode: e.target.value });
			},
		},
		{
			id: 'offsegPassword',
			label: common.label.password,
			type: 'password',
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setOffsegAuthInfo({ ...offsegAuthInfo, password: e.target.value });
			},
		},
	];
};

export const registerFromList = (
	g500LiteAuthInfo: G500LiteAuthInfoType,
	setG500LiteAuthInfo: React.Dispatch<React.SetStateAction<G500LiteAuthInfoType>>,
) => {
	return [
		{
			id: 'companyId',
			label: common.label.companyId,
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setG500LiteAuthInfo({ ...g500LiteAuthInfo, companyId: e.target.value });
			},
		},
		{
			id: 'loginId',
			label: common.label.loginId,
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setG500LiteAuthInfo({ ...g500LiteAuthInfo, loginId: e.target.value });
			},
		},
		{
			id: 'G500LitePassword',
			label: common.label.password,
			type: 'password',
			onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
				setG500LiteAuthInfo({ ...g500LiteAuthInfo, password: e.target.value });
			},
		},
	];
};
